module.exports = __webpack_public_path__ + "media/images/emblems/Guettingen-Blazono-60cd565da2977151e80ff69a3eaf396f.png";